import { ApplicationState } from '../../types';
import { getEnterpriseServiceId } from '../entities/services/selectors';
import { getSelectedHotelId } from '../resourceOrder/selectors';

export const getServiceCategoryMappings = (state: ApplicationState) => {
    const enterpriseId = getSelectedHotelId(state);
    const enterpriseServiceId = getEnterpriseServiceId(state, { enterpriseId });

    return enterpriseServiceId != null ? state?.data?.serviceCategoryMappings.data[enterpriseServiceId] : null;
};
